import { useEffect } from "react";

import L from 'leaflet';

import { loadGEO } from "../../../helpers/helpers";
import { flip } from "turf";

const l = L.featureGroup();          

export const Precipitation = ({mapRef}) => {

    const precOptions = { color: 'grey', border: '0' };

    useEffect(() => {
        loadGEO('prec')
        .then((data) => {
            onDraw(flip(data));
        });
        return () => {
            onClear();
        }
    }, []);

    const onDraw = ( polygons ) => {        

        if (polygons.features.length > 0) {
            polygons.features.forEach((feature, index) => {                
                const polygon = L.polygon([feature.geometry.coordinates], precOptions)
                l.addLayer(polygon);
            })
        }
        l
            .bringToFront()
            .addTo(mapRef.current);

    }

    const onClear = () => {
        l.clearLayers();        
    }
    
    return;

}